import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useEffect, useMemo, useState } from "react";

import SelectFormik from "../../../../common/components/form/SelectFormik";
import ButtonWithLoader from "../../../../common/components/ui/loading/ButtonLoading";
import { getCompanyId } from "@/common/services/company.api";
import { getCompanyList } from "@/common/helpers/company.helpers";

const validationSchema = Yup.object().shape({
  destinyCity: Yup.string().required("Cidade de destino é obrigatório"),
  originCity: Yup.string().required("Cidade de origem é obrigatório"),
});
type FormPropsCreateTransferVehicle = {
  onSubmit: (values: {
    companyOriginId: string;
    companyDestinyId: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }) => Promise<any>;
};

function FormCreateVehicleTransfer(props: FormPropsCreateTransferVehicle) {
  const [initialValues, setInitialValues] = useState({
    destinyCity: "",
    originCity: "",
  });

  const { cityNames, nameToIdMap, idToNameMap } = useMemo(() => {
    const list = getCompanyList();

    const names = list.map((info) => info.name);

    const nameToId = list.reduce((acc, info) => {
      acc[info.name] = info.id;
      return acc;
    }, {} as Record<string, string>);

    const idToName = list.reduce((acc, info) => {
      acc[info.id] = info.name;
      return acc;
    }, {} as Record<string, string>);

    return { cityNames: names, nameToIdMap: nameToId, idToNameMap: idToName };
  }, []);

  useEffect(() => {
    const fetchUserCity = async () => {
      try {
        const userCityId = await getCompanyId();
        if (userCityId) {
          const userCityName = idToNameMap[userCityId];
          if (userCityName) {
            setInitialValues((prevValues) => ({
              ...prevValues,
              originCity: userCityName,
            }));
          }
        }
      } catch (error) {
        console.error("Erro ao buscar a cidade do usuário:", error);
      }
    };
    fetchUserCity();
  }, [idToNameMap, cityNames]);

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);

    const originId = nameToIdMap[values.originCity];
    const destinyId = nameToIdMap[values.destinyCity];

    const payload = {
      companyOriginId: originId,
      companyDestinyId: destinyId,
    };

    await props.onSubmit(payload);

    setSubmitting(false);
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize={true}
    >
      {({ isSubmitting }) => (
        <Form>
          <SelectFormik
            label="Cidade de origem:"
            name="originCity"
            options={cityNames}
            className="w-full"
            required={true}
          />
          <SelectFormik
            label="Cidade de destino:"
            name="destinyCity"
            options={cityNames}
            className="w-full"
            required={true}
          />
          <div className="flex justify-end mt-8">
            <ButtonWithLoader type="submit" isLoading={isSubmitting}>
              Enviar
            </ButtonWithLoader>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default FormCreateVehicleTransfer;
